export const openUrl = (url) => fetch(url);
